import { arePropertiesDefined } from ".";
import { NonNilProperty } from "../types";

export function arePropertiesDefinedCb<T, K extends keyof T>(
    ...fields: K[]
): (value: T | null | undefined) => value is NonNilProperty<T, K> {
    return (value: T | null | undefined): value is NonNilProperty<T, K> => arePropertiesDefined(value, ...fields);
}
